import { GESCHAEFTS_ART } from "../../utils/enums";
import Select from "./Select";

const InputGeschaeftsart = (props) => {
  const { ...attributes } = props || {};

  const options = Object.keys(GESCHAEFTS_ART).map(g => {
    const status = GESCHAEFTS_ART[g];
    return <option key={"ga_" + status.KEY} value={status.KEY}>{status.BEZEICHNUNG}</option>;
  });
  options.unshift(<option key="default" value="">Keine Auswahl</option>);
  return <Select {...attributes}>{options}</Select>;
};
export default InputGeschaeftsart;
